(function() {
  "use strict";

  angular.module("sempraWebapp").constant("plTranslations", {
    MESSAGE:"Message",
    ERROR_TITLE:"Błąd",
    ERROR_MESSAGE:"Wystąpił błąd podczas realizacji zadania”",
    ERROR_LOGIN:"Błąd podczas logowania. Nieprawidłowy adres e-mali lub hasło. Spróbuj ponownie”",
    OK:"OK",
    CANCEL:"Anuluj",
    YES:"Tak",
    NO:"Nie",
    FROM:"Od",
    TO:"Do",
    DELETE:"Usuń",
    SIGN_OUT:"Wyloguj się",
    NAME:"Imię",
    DATE:"Data",
    PIECES:"sztuki",
    HOURS:"Godziny",
    DAYS:"Dni",
    MONTH:"Miesiąc",
    MONTHS:"Miesiące",
    YEAR:"Lata",
    BOX:"Stanowisko / Boks",
    SEARCH:"Szukaj",
    ALL_USERS:"Wszyscy użytkownicy",
    ARE_YOU_SURE:"Powrót?",
    BACK:"Kwota",
    AMOUNT:"Opis",
    DESCRIPTION:"Opis",
    FORGOT_PASSWORD_ERROR_MSG:"Czy jesteś pewien",
    REQUIRED_FIELD:"Pole obowiązkowe",
    LOGOUT_TITLE:"Czy na pewno chcesz się wylogować?",
    LOGOUT_MSG:"Niezachowane zmiany zostaną usunięte",
    ACTIVATION_ACCOUNT:"Pomyślna aktywacja konta, przejdź do ekranu logowania",
    UNKNOWN_ERRROR_NOTIFICATION:"Kontynuuj",
    CONTINUE:"Wystąpił nieznany błąd",
    DATA_NOT_AVAILABLE:"Dane nie są dostępne",
    SELECT:"Wybierz",
    UPLOAD:"Wyślij",
    PHONE:"Telefon",
    WEBSITE:"Strona internetowa",
    WORKING_HOURS:"Godziny pracy",
    INSERT:"Wpisz",
    TEXT:"Tekst",
    CREATED:"Tworzona",
    VALID_UNTIL:"Ważne do",
    SAVE:"Zachowaj",
    TOKENS:"Żetony",
    DELETE_COMPANY_HISTORY:"Usuń historię firmy?",
    DELETE_COMPANY_HISTORY_MESSAGE:" WARNING: After pressing this button, all transactions of your car wash will be permanently deleted! This data cannot be restored after deletion.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Are you sure you want to permanently delete all transaction data?",
    HISTORY_SUCCESSFULY_DELETED:"History successfuly deleted",
    HELP:"Wsparcie",
    VALUE:"Wartość",
    ACTIVATING_ACCOUNT_ERROR:"Wystąpił błąd podczas aktywacji konta R2W. Spróbuj ponownie, gdy problem nie ustąpi, skontaktuj się z support@sempra.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Witamy w myjni samochodowej Kärcher",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Witaj w R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Wpisz i powtórz hasło, aby aktywować swoje konto R2W. Automatyczne logowanie nastąpi po pomyślnej weryfikacji hasła",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Można zmienić ustawienia użytkownika w aplikacji",
    ENTER_NEW_PASSWORD:"Wprowadź nowe hasło",
    REPEAT_NEW_PASSWORD:"Powtórz hasło",
    PASSWORD_MIN_LENGTH:"Hasło musi mieć co najmniej 8 znaków",
    PASSWORD_MAX_LENGHT:"Hasło nie może mieć więcej niż 32 znaki",
    PASSWORD_PATTERN:"Hasło musi zawierać przynajmniej jedną wielką i jedną małą literę",
    PASSWORD_MATCH:"Hasła nie pasują do siebie",
    ACTIVATE:"Aktywuj",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Pomyślnie przesłałeś żądanie. Sprawdź, czy otrzymałeś wiadomość e-mail z potwierdzeniem",
    VALIDATION_REQUIRED:"Pole obowiązkowe",
    VALIDATION_EMAIL:"Nieprawidłowy adres e-mail",
    VALIDATION_INTEGER_NUMBER:"Wprowadzona wartość musi być liczbą całkowitą",
    VALIDATION_HOURS_VALUE:"Wartość musi wynosić pomiędzy 0-23",
    VALIDATION_MINUTES_VALUE:"Wartość musi wynosić pomiędzy 0-59",
    VALIDATION_NOT_A_DATE:"Wprowadzona wartość nie jest datą",
    VALIDATION_FROM:"Data większa od ostatniej daty",
    VALIDATION_TO:"Data mniejsza od początkowej daty",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Podane informacje są już w bazie",
    PASSWORD_VALIDATION_PATTERN_NEW:"Hasło musi zawierać przynajmniej jedną wielką literę i jedną cyfrę. Puste pola nie są dozwolone",
    VALIDATION_PERCENT_VALUE:"Wartość musi wynosić pomiędzy 1-999",
    NUMBERS_ONLY_100:"Numer do 100",
    NUMBERS_ONLY_1000:"Numer do 1000",
    POSITIVE_NUMBERS_ONLY:"Tylko liczba dodatnia",
    GRID_PAGER_PAGE:"Strona",
    GRID_PAGER_ROWS_PER_PAGE:"Wiersze na stronie",
    GRID_PAGER_PAGE_OF:"od",
    BREAD_CRUMBS_HOME:"Główna",
    BREAD_CRUMBS_DASHBOARD_TECH:"Przegląd myjni",
    BREAD_CRUMBS_DETAILS:"Szczegóły",
    BREAD_CRUMBS_SETTINGS:"Ustawienia",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Całkowity raport finansowy z poszczególnych dni",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Raport finansowy dobowy",
    BREAD_CRUMBS_NEW_USER_GROUP:"Tworzenie grupy użytkowników",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Edycja grupy użytkowników",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Tworzenie szablonu kamapanii",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Edycja szablonu kampanii",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Tworzenie kampanii",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Edycja kampanii",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Raport finansowy okresowy",
    LOGIN:"Logowanie",
    EMAIL:"E-mail",
    PASSWORD:"Hasło",
    LANGUAGE:"Język",
    FORGOT_PASSWORD:"Zapomniałeś hasło?",
    SUBMIT:"Zatwierdź",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Liczba oczekujących alarmów",
    HEADER_VIEW_ALL_ALARMS:"Zobacz wszystkie alarmy…",
    HEADER_MY_ACCOUNT:"Moje konto",
    HEADER_ACCOUNT_MANAGEMENT:"Zarządzanie kontami",
    ACCOUNT_ALREADY_EXIST:"Adres e-mail jest już zajęty",
    NEWSLETTER_CONFIRMATION:"Wyślij powiadomienie e-mailem o stanie alarmów",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Dzienny przegląd finansowy",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Przegląd myjni",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Deska rozdzielcza",
    ASIDE_MENU_ALARMS:"Alarmy",
    ASIDE_MENU_FACILITIES:"Myjnie",
    ASIDE_MENU_REPORTS:"Raporty",
    ASIDE_MENU_LOYALTY:"Kampanie",
    ASIDE_MENU_USER_GROUPS:"Grupy użytkowników",
    ASIDE_MENU_PERIODIC_SUMMARY:"Przegląd okresowy",
    ASIDE_MENU_NEWS:"Wiadomości",
    DAILY_FINANCES_TOTAL_MONEY:"Całkowita suma pieniędzy",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Całkowita suma z wszystkich myjni",
    DAILY_FINANCES_TOTAL_COINS:"Łącznie zużytych metalowych tokenów",
    DAILY_FINANCES_DOWNLOAD_CSV:"Pobierz CSV",
    DAILY_FINANCES_ONLINE:"Online",
    DAILY_FINANCES_OFFLINE:"Gotówka",
    DAILY_FINANCES_CHANGER:"Gotówka w rozmieniarce",
    DAILY_FINANCES_COINS:"Żetony",
    REPORTS_FILTER:"Filtr",
    REPORTS_TYPE_OF_REPORT:"Typ raportu",
    REPORTS_CHOOSE_FACILITY:"Wybór myjni",
    REPORTS_PERIOD_1:"Okres 1 – ",
    REPORTS_PERIOD_2:"Okres 2 – ",
    MONEY_BY_DATE_REPORT:"Całkowity raport dzienny",
    R2W_BY_DATE_REPORT:"Wszystkie płatności z poszczególnych dni online",
    COINS_BY_DATE_REPORT:"Liczba wszystkich żetonów z dnia",
    AVG_MONEY_BY_HOUR_REPORT:"Średnia kwota z godziny",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Średnia kwota z dnia",
    AVG_MONEY_BY_BOX_REPORT:"Wydatki przez washbox",
    COMPARE_PERIODS_REPORT:"Raport porównawczy z myjni",
    TOTAL_USERS_BY_GROUP:"Łącznie użytkowników z dnia",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"użytkownicy",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"odwiedziny",
    VISITS_COUNT_REPORT:"Liczba użytkowników według wizyt",
    LOYALTY_PER_DAY_REPORT:"Wydane kredyty z dnia",
    LOYALTY_PER_PAYMENT_METHOD:"Lojalność według sposobu płacenia",
    VISITS:"Wizyty",
    VISIT:"Wizyta",
    TOTAL_SPENT_MONEY:"Całkowita liczba wydanych środków",
    MONEY:"Pieniądze",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Całkowity raport wydanych środków za okres",
    DOWNLOAD_CSV:"Ściągnij CSV",
    TOTAL_SPENT_COINS:"Całkowita liczba wykorzystanych żetonów",
    TOTAL_USERS:"Całkowita liczba użytkowników",
    TOTAL_CREDIT_GIVEN:"Łącznie wydany kredyt",
    EUROKEY_BY_DATE_REPORT:"Całkowity raport płatności EuroKey",
    TOTAL_SPENT_EUROKEY:"Wydane razem",
    SELECT_TYPE_OF_REPORT:"Musisz wybrać rodzaj raportu :)",
    NUMBER_OF_VISITS_TITLE:"Liczba odwiedzin",
    NUMBER_OF_USERS_TITLE:"Liczba użytkowników",
    PIECES_TITLE:"Część",
    TOTAL_VISITS:"Łączna liczba odwiedzin",
    TOKENS_TITLE:"żeton",
    SEARCH_USERS_NO_RESULTS:"Brak użytkowników dla danego kryterium wyszukiwania",
    SEARCH_USERS:"Wyszukiwanie użytkowników",
    SEARCH_TELEPHONES:"Wyszukiwanie według numeru telefonu",
    ADD_USER_TO_GROUP:"Dodaj użytkownika do grupy",
    REMOVE_USER_FROM_GROUP:"Usuń użytkownika z grupy",
    USER_GROUP_NAME_REQUIRED:"Nazwa grupy użytkowników jest obowiązkowa",
    USER_GROUP_NAME:"Nazwa grupy użytkowników",
    USER_GROUPS_OVERVIEW:"Przegląd grupy użytkowników",
    USER_COUNT:"Liczba użytkowników",
    NEW_USER_GROUP:"Utwórz nową grupę użytkowników",
    DELETE_USER_GROUP:"Usuń grupę użytkowników",
    UPDATE_USER_GROUP:"Edytuj grupę użytkowników",
    DELETE_USER_GROUP_ERROR:"Wystąpił błąd podczas usuwania wybranych grup użytkowników. Proszę spróbować ponownie lub skontaktować się z pomocą techniczną…",
    CONFIRM_DELETE_USER_GROUP:"Czy jesteś pewien, że chcesz usunąć wybraną grupę użytkowników?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Działania, które były przypisane grupie nie będą ważne dla użytkowników usuniętej grupy",
    GROUP_NAME_MAX_LENGTH:"Nazwa grupy powinna być mniejsza niż 255 znaków",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Użytkownik należy już do danej grupy",
    MISSING_USER:"Missing user(en)",
    USER_NOT_ON_LIST:"User is not in the active users list. Check if the email address is valid and try again(en).",
    UPLOAD_USER_GROUP:"Upload user group list from *.csv file",
    UKNOWN_USERS:"List of uknown users",
    CAMPAIGN_TEMPLATE_RULE:"Zasada kampanii",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Wystąpił błąd podczas usuwania wybranego szablonu kampanii. Spróbuj ponownie lub skontaktuj się z pomocą techniczną…",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Potwierdź usunięcie wybranego szablonu kampanii",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Czy na pewno chcesz usunąć wybrany szablon kampanii?",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Przegląd szablonów kampanii",
    DELETE_CAMPAIGN_TEMPLATE:"Usuń szablon kampanii",
    UPDATE_CAMPAIGN_TEMPLATE:"Aktualizuj szablon kampanii",
    CREATE_CAMPAIGN_TEMPLATE:"Utwórz nowy szablon kampanii",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Wymagana nazwa szablonu kampanii",
    CAMPAIGN_TEMPLATE_NAME:"Nazwa szablonu kampanii",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Pole obowiązkowe",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"upominki %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"Dodatkowy czas",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Najpierw wybierz typ. Myj pudła lub małe maszyny.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Usuń regułę",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Od",
    CAMPAIGN_TEMPLATE_RULE_TO:"do",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"godziny",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minuty",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Nowa reguła w zależności od liczby wizyt",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Nowa reguła przez ilość żetonów spędził",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Nowa zasada w zależności od dnia tygodnia",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Dodaj nową zasadę",
    CAMPAIGN_TEMPLATE_RULE_1:"Każdy / Wszystkich",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Każdy / Wszystkich",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"Żetony za mniej niż",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"wizyty za mniej niż",
    CAMPAIGN_TEMPLATE_RULE_3:"dni, podarunki",
    CAMPAIGN_TEMPLATE_RULE_4:"Żetony",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Lista zasad jest pusta",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Data nie może być w przeszłości",
    DELETE_CAMPAIGN_ERROR:"Wystąpił błąd podczas usuwania wybranej kampanii. Spróbuj ponownie lub skontaktuj się ze wsparciem technicznym…",
    CONFIRM_DELETE_CAMPAIGN:"Czy jesteś pewien, że chcesz usunąć daną kampanię?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W nie odpowiada za doświadczenia użytkownika wynikające z tej akcji.",
    CAMPAIGNS_OVERVIEW:"Przegląd kampanii",
    DELETE_CAMPAIGN:"Usuń kampanię",
    UPDATE_CAMPAIGN:"Aktualizuj kampanię",
    CREATE_CAMPAIGN:"Utwórz nową kampanię",
    CAMPAIGN_ACTIVE:"Aktywna",
    CAMPAIGN_TEMPLATE:"Szablon",
    CAMPAIGN_GROUPS:"Grupy",
    CAMPAIGN_ALL_USERS:"Wszyscy użytkownicy",
    CAMPAIGN_NAME:"Nazwa kampanii",
    CAMPAIGN_NAME_REQUIRED:"Wymagana nazwa kampanii",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Użytkownicy blisko limitu dziennej premii",
    MESSAGE_TO_USERS:"Wiadomość do wybranych użytkowników",
    SEND_MESSAGE:"Wyślij wiadomość",
    THRESHOLD:"Limit",
    TYPE:"Typ",
    TOTAL_MONEY_SPENT:"Całkowita suma środków wydanych w kampanii",
    NUMBER_OF_VISITS:"Całkowita liczba wizyt w ramach kampanii",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Wiadomość musi mieć co najmniej 10 znaków",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Wiadomość nie może mieć więcej niż 350 znaków",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Tekst wiadomości jest obowiązkowy",
    TECHNOLOGY:"Technologia",
    TAP_WATER:"Woda z kranu",
    REVERSE_OSMOSIS:"Odwrócona osmoza",
    SOFTENED_WATER:"Zmiękczona woda",
    DOSER:"Dozownik",
    STATUS:"Status",
    LAST_SYNCHRONIZATION:"Ostatnia synchronizacja",
    NO_OF_CURRENT_ALARMS:"Liczba bieżących alarmów",
    NO_OF_CURRENT_WARNINGS:"Liczba bieżących ostrzeżeń",
    WEATHER:"Pogoda",
    BOXES_WORK_HOURS_COUNTERS:"Licznik godzin pracy boksu",
    BOX_TOTAL_HOURS:"Całkowita liczba godzin pracy",
    BOX_SERVICE_HOURS:"Całkowita liczba godzin pracy (serwis)",
    BOX_COUNTER_HOURS:"Godziny",
    ALARMS_AND_WARNINGS:"Alarmy i ostrzeżenia",
    FILTER_AND_BOILER:"Filtr i bojler",
    FILTER_TOTAL_DAYS:"Dni pracy filtra",
    BOILER_TOTAL_DAYS:"Dni pracy bojlera",
    DAYS_UNIT:"dni",
    SOFTENER:"Zmiękczacz",
    MANUAL_COLD_DRAIN:"Ręczny odpływ zimnej wody",
    EL_COLD:"El. zimny",
    DRAIN:"odpływ",
    TAP:"kran",
    WASTE:"Odpad",
    OSMOSIS:"osmoza",
    DEMI_WATER:"Woda deminaralna",
    EL_RINSE:"El. m. płukanie",
    BOILER:"Bojler",
    EL_WAX:"El. m. wosk",
    FLOOR_HEATING:"Ogrzewanie podłogowe",
    DOSER_TANK:"Zbiornik dozownika",
    EL_WASH:"El. m. mycia",
    DETERGENT:"Detergent",
    VIBRATOR:"Wibrator",
    UPDATE_FACILITY_SETTINGS:"Aktualizacja ustawień myjni",
    GENERAL_SETTINGS:"Ustawienia ogólne",
    LIGHTS:"Światło",
    GROUPS:"Grupy",
    ANTI_FREEZE:"Środek przeciw zamarzaniu",
    AUTO:"Auto",
    MANUAL:"Ręcznie",
    ON:"Włączone",
    OFF:"Wyłączone",
    TEMPERATURE:"Temperatura",
    UPDATE_DEVICE:"Aktualizacja ustawień myjni",
    BOX_CLEAN_HOURS:"Licznik godzin pracy stanowiska (czyszczenie)",
    GROUP_COUNTERS:"Liczniki grup",
    RESET:"Reset",
    CASH_COUNT:"Licznik monet",
    COINS_COUNT:"Licznik żetonów",
    EUROKEY_COUNT:"Licznik Eurokey",
    DOSER_WORK:"Czas pracy dozownika (sec.)",
    DOSER_PAUSE:"Czas przerwy dozownika (sec.)",
    DELAY_BFV:"BFV opóźnienie (ms)",
    DELAY_6M1:"6M1 opóźnienie (ms)",
    DELAY_LPS:"LPS opóźnienie (ms)",
    RESET_CASH_COUNT_ALL:"Wyzerowanie wszystkich liczników monet",
    RESET_COINS_COUNT_ALL:"Wyzerowanie wszystkich liczników żetonów",
    RESET_EUROKEY_COUNT_ALL:"Wyzerowanie wszystkich liczników Eurokey",
    FACILITY_DETAILS:"Szczegóły myjni",
    FACILITY_NAME:"Nazwa myjni",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Pomyślne przesłanie obrazu",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Pomyślna zmiana danych",
    CONNECTED:"połączony",
    OFFLINE:"niepowiązany",
    MESSAGES_FILTER:"Filtr wiadomości",
    FACILITY:"Myjnia",
    APPLY:"Zastosuj",
    TIME:"Czas",
    LOCATION:"Lokalizacja",
    ACKNOWLEDGED:"Potwierdzone",
    FILTERED_MESSAGES:"Przefiltrowane wiadomości",
    ACK:"Potwierdzone",
    NOT_ACK:"Nie potwierdzone",
    ALL:"Wszystkie / Wszystko",
    ALL_FACILITIES:"Wszystkie myjnie",
    ENTER_DATE_PLACEHOLDER:"Wprowadź datę",
    OP_NESTANAK_NAPONA:"Awaria zasilania – 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"Błąd pompy MZS",
    OP_UPR_NAPON_24VAC_GRE:"Kierowanie napięciem 24 V AC błąd wyłącznika obwodu – 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Pusty zbiornik świeżej wody",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Wyłączony wyłącznik pompy wodnej",
    OP_MIN_NIVO_OMEKS_VODE:"Pusty zbiornik zmiękczonej wody",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Błąd wyłącznika pompy zmiękczonej wody",
    OP_MIN_NIVO_DEMIN_VODE:"Pusty zbiornik wody osmotycznej",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Błąd wyłącznika pompy wody osmotycznej",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Błąd wyłącznika pompy produkujące osmozę",
    OP_BOJLER_GRESKA_MZS:"Błąd bojlera",
    OP_CRPKA_PRASKA_GRE_MZS:"Błąd wyłącznika pompy bojlera",
    OP_DOZATOR_PRASKA_GRE_MZS:"Błąd wyłącznika dozującego proszek",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Błąd wyłącznika wibratora dozującego proszek",
    OP_MIN_PRASAK_TON_ALARM:"Pusty zbiornik mieszający proszek",
    OP_USIS_KOV_TURBINA_GRESKA:"Błąd wyłącznika turbiny zasysającej monety",
    OP_FILTER_VODE_ZACEPLJEN:"Zablokowany filtr wody",
    OP_VISKTL_RESET_SATI_RADA:"Serwis pompy wysokociśnieniowej",
    OPW_VISKTL_RESET_SATI_RADA:" High pressure pump service",
    OP_FILTER_DANI_RADA:"Serwis filtra",
    OP_BOJLER_DANI_RADA:"Serwis bojlera",
    OPW_ALARM_VISOKOTL_PUMPA:"Alarm pompy wysokociśnieniowej",
    OPW_ALARM_FILTER_SERVIS:"Alarm serwisu filtra",
    OPW_ALARM_BOJLER_SERVIS:"Alarm serwisu bojlera",
    HAS_MEMBERS:"Wybrana grupa ma członków i nie można jej usunąć. Członkowie muszą zostać najpierw usunięci.",
    PERIODIC_SUMMARY_FOR:"OKRESOWE PODSUMOWANIE ZA",
    PERIODIC_SUMMARY_REPORTS:"Okresowe podsumowanie",
    DATE_RANGE:"Zakres dat",
    FINANCIAL_REPORT:"Raport finansowy",
    GROSS_INCOME:"Całkowity przychód",
    GROSS_INCOME_SUM:"Suma całkowitego przychodu",
    COMMISSION_FEE:"Prowizje",
    NET_INCOME:"Zysk netto (do rozliczenia)",
    COMMISSION_FEE_DETAILS:"Prowizja obejmuje transakcje bankowe / PayPal lub usługodawcę usług SMS",
    LOYALTY_CREDITS_REPORT:"Raport dotyczący lokalnych tokenów",
    LOYALTY_GIVEN:"Biorąc pod uwagę lokalne żetony",
    LOYALTY_USED:"Używane lokalne tokeny",
    LOYALTY_SOLD:"Załadowano lokalne tokeny",
    LOYALTY_TOTAL:"Całkowity",
    LOYALTY_CURRENT_MONTH:"Bieżący miesiąc",
    SOMETHING_WENT_WRONG:"Uuuuuuuuuuups, pojawił się błąd :-(",
    MISSING_PAGE:"Nie można odnaleźć podanej strony",
    TRY_AGAIN:"Spróbuj ponownie",
    DEFAULT_ERROR_NAME:"Wystąpił nieznany błąd",
    DEFAULT_ERROR_DESCRIPTION:"Spróbuj ponownie, jeśli problem będzie się powtarzał skontaktuj się z upoważnioną osobą",
    MY_ACCOUNT_DETAILS:"Szczegóły konta użytkownika",
    SAVE_CHANGES:"Zachowaj zmiany",
    USERNAME:"Nazwa użytkownika",
    FIRST_NAME:"Imię",
    LAST_NAME:"Nazwisko",
    USER_ROLE:"Grupa użytkowników",
    OLD_PASSWORD:"Stare hasło",
    NEW_PASSWORD:"Nowe hasło",
    OLD_PASSWORD_REQUIRED:"Stare hasło jest wymagane",
    NEW_PASSWORD_REQUIRED:"Nowe hasło jest wymagane",
    NEW_PASSWORD_REPEAT:"Powtórzenie nowego hasła jest wymagane",
    NEW_PASSWORD_NOT_MATCH:"Stare i nowe hasła nie są identyczne",
    PASSWORD_DIFFERENT_VALIDATION:"Nowe hasło musi być inne od starego",
    PASSWORD_MIN_CHAR:"Twoje hasło musi mieć przynajmniej 8 znaków",
    PASSWORD_MAX_CHAR:"Twoje hasło musi mieć maksymalnie 32 znaki",
    PASSWORD_PATTERN_VALIDATION:"Hasło powinno mieć przynajmniej jedną cyfrę, jedną małą i jedną wielką literę",
    ACCOUNT_MANAGEMENT:"Zarządzanie użytkownikami",
    NOT_ACTIVE:"Nieaktywny",
    ASSIGN_ROLE:"Grupa użytkowników",
    UPDATE:"Aktualizuj",
    ADD_NEW_ACCOUNT:"Dodawanie nowego użytkownika",
    EMAIL_REQUIRED:"Adres e-mail jest obowiązkowy",
    EMAIL_NOT_VALID:"Adres e-mail nie jest poprawny",
    ADD_NEW_USER_TEXT:"E-mail z linkiem aktywacyjnym zostanie wysłany na podany adres",
    UPDATE_USER_NOTIFICATION:"Pomyślnie zaktualizowane dane",
    CHANGED_PASSWORD_NOTIFICATION:"Pomyślna zmiana hasła",
    UPDATE_USER_GROUP_NOTIFICATION:"Pomyślna zmiana nazwy grupy",
    CREATE_USER_GROUP_NOTIFICATION:"Pomyślnie utworzono grupę",
    DETELE_USER_GROUP_NOTIFICATION:"Pomyślnie usunięto grupę",
    EMPTY_GROUP_LIST_MSG:"Nie ma utworzonej grupy. Rozpocznij od utworzenia grupy",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Pomyślnie usunięto użytkownika z grupy",
    ADD_USER_TO_GROUP_NOTIFICATION:"Pomyślnie dodano użytkownika do grupy",
    ADD_USER_NOTIFICATION:"Pomyślnie dodanie nowego użytkownika",
    DELETE_USER_NOTIFICATION:"Pomyślnie usunięto użytkownika",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Aby utworzyć grupę użytkowników proszę wpisać nazwę grupy",
    DELETE_USER:"Usuwanie użytkownika",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Czy jesteś pewien, że chcesz usunąć użytkownika z grupy?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Szanowni Państwo, jeśli odwiedzicie nas w trakcie trwania kampanii otrzymacie dodatkowy bonus na koncie",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Zasady kampanii za liczbę wizyt",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Zasady kampanii za wydane środki finansowe",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Zasady kampanii na dni tygodnia",
    REMOVE_CAMPAIGN_RULE_TITLE:"Usuwanie zasad kampanii",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Czy na pewno chcesz usunąć zasadę kampanii?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Pomyślnie zachowana zasada kampanii",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Pomyślna aktywacja kampanii",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Brak utworzonych kampanii. Aby rozpocząć należy utworzyć pierwszą",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Pomyślnie wysłano wiadomość",
    COMPANY_ACCOUNTS:"Konta firmowe",
    BUSSINESS_INVOICES_LIST:"Moje faktury B2B",
    LOCALE_TOKEN:"Lokalny token",
    R2W:"Globalny token",
    START_MONTH:"Rozpocznij miesiąc",
    END_MONTH:"Koniec miesiąca",
    TOKEN_TYPE:"Typ tokena",
    TOKEN_NUMBER:"Numer tokena",
    NOTHING_TO_DISPLAY:"* Nic do wyświetlenia",
    CREATE_INVOICE:"Nowa Faktura",
    INVOICE:"Faktura",
    INVOICES:"Faktury",
    EDIT_INVOICE:"Zmień Fakturę",
    UPDATE_INVOICE_NOTIFICATION:"Pomyślna zmiana statusu faktury na 'w realizacji'",
    CURRENT_CHARGES:"Obciążenia za bieżący okres",
    PAYMENTS_ON_HOLD:"Faktury w realizacji",
    FOR_INVOICING:"Niezafakturowane",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Spróbuj anulować fakturę",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Czy na pewno chcesz anulować fakturę???",
    INVOICING_NOTIFICATION_HEADER:"Masz zamiar wysłać fakturę",
    INVOICING_NOTIFICATION_TEXT:"Czy na pewno chcesz wysłać fakturę?",
    SENT_INVOICE_NOTIFICATION:"Pomyślnie wysłałeś fakturę",
    CANCELED_INVOICE_NOTIFICATION:"Pomyślnie anulowano fakturę",
    INVOICE_DESCRIPTION_TEXT:"Faktura za miesiąc",
    INVOICE_STATE:"Status faktury",
    INVOICE_NUMBER:"Numer faktury",
    INVOICE_TOTAL:"Ogółem",
    SELECT_YEAR:"Wybierz rok",
    DOWNLOAD:"Pobierz PDF",
    INVOICE_NUMBER_HEADER:"Zamierzasz wysłać fakturę z numerem",
    INVOICE_PAYMENT_CONFIRMATION:"Zamierzasz potwierdzić płacenie faktury z numerem",
    INSERT_INVOICE_NUMBER:"Wprowadź numer faktury",
    INVOICED_WARNING:"Email nie został wysłany. Proszę zaczekać…",
    SEND_INVOICE:"Wyślij",
    INVOICE_ALL:"Wszystkie",
    INVOICE_FROM_R2W:"Od R2W",
    INVOICE_TO_R2W:"Dla R2W",
    PAYMENT_REQUEST:"Prośba o zapłatę",
    PAYMENT_REQUEST_STATE:"Stan żądania płatności",
    PAYMENT_REQUEST_NUMBER:"Numer wniosku o płatność",
    FOR_PAYMENT_REQUEST:"Do żądania zapłaty",
    PAYMENT_REQUEST_ON_HOLD:"Żądanie płatności w przetwarzaniu",
    DOWNLOAD_INVOICE:"Pobierz fakturę",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Kliknij, aby pobrać opcje",
    B2B_SPEC:"B2B Specyfikacja",
    B2C_SPEC:"B2C Specyfikacja",
    DOWNLOAD_PAYMENT_REQUEST:"Pobierz prośbę o płatność",
    LOYALTY_PREVIEW:"Przegląd kampanii",
    ACTIVATED:"Aktywna",
    RUNNING:"Trwa",
    NOT_ACTIVATED:"Nieaktywna",
    FINISHED:"Zakończona",
    DEPRECATED:"Przestarzała",
    UPCOMING:"Nadchodząca",
    NONE:"Nikt",
    STARTED:"Rozpoczęta",
    ENDS:"Kończy się",
    DEDICATED:"Przydzielona",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Masz zamiar aktywować",
    CAMPAIGN:"kampania",
    SEND_MESSAGE_NOTIFICATION:"Czy chcesz wysłać wiadomość wszystkim grupom użytkowników?",
    DIVISIBLE_TO_NUMBER:"Liczba powinna być podzielna za pomocą ",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Rodzaj urządzenia",
    LISTENER:"Małe maszyny",
    BRIDGE:"Umyć pudełka",
    WASH_BOXES:"Umyć pudełka",
    VACUUMS:" Vacuums",
    SAVE_NEWS:"Zachowaj wiadomość",
    CREATE_NEW_NEWS:"Utwórz nową wiadomość",
    HISTORY_OF_ALL_NEWS:"Historia wszystkich wiadomości",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Wpisz nazwę myjni",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Dodaj nową myjnię",
    NEWS_TEXT:"Tekst wiadomości",
    NEWS_TITLE:"Tytuł wiadomości",
    DELETE_NEWS_CONFIRMATION:"Chcesz usunąć wiadomość?",
    NEWS_DELETE_NOTIFICATION:"Pomyślnie usunięta wiadomość",
    NEWS_SAVE_NOTIFICATION:"Pomyślnie zachowana wiadomość",
    NEWS_CREATION_DATE:"Data utworzenia",
    NO_TITLE:"Brak tematu",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Tekst wiadomości nie może być dłuższy niż 255 znaków",
    NEWS_TEXT_REQUIRED_VALIDATION:"Tekst wiadomości jest wymagany",
    NEWS_TITLE_REQUIRED_VALIDATION:"Tytuł wiadomości jest wymagany",
    DEACTIVATE:"Dezaktywuj",
    ASIDE_MENU_LOCAL_TOKENS:"Żetony lokalne",
    CREATE_NEW_LOCAL_TOKENS:"Wydawanie nowych lokalnych żetonów",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Wprowadź adres email użytkownika i numer żetonu, który chcesz mu wydać",
    CREATE_TOKENS:"Wydaj żetony",
    MINIMUM_ONE_TOKEN:"Wartość musi być większa od 0",
    CUSTOMER_EMAIL:"Adres email użytkownika",
    AMOUNT_OF_TOKENS:"Liczba żetonów",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Pomyślne wydanie lokalnych tokenów dla",
    PROBLEM_ISSUING_LOCAL_TOKENS:"„Wystąpił błąd podczas wydawania żetonów. Sprawdź adres e-mail użytkownika i spróbuj ponownie",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Przegląd wydanych lokalnych żetonów",
    ISSUED_AT:"Czas wydania",
    ISSUED_BY:"Wydane przez",
    CODE:"Kod",
    REDEEMED_BY:"Wykorzystane przez",
    REDEEMED_AT:"Czas",
    ASIDE_MENU_VOUCHERS:"Kupony",
    PRINT:"Druk",
    VOUCHERS_OVERVIEW:"Przegląd kuponów",
    CREATE_NEW_VOUCHERS:"Tworzenie nowych kuponów",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Utwórz nową serię kuponów wpisując liczbę żetonów w serii i kod prefiksu dla serii",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Ilość żetonów na kupon",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Na jeden kupon można przydzielić od 1 do 100 żetonów",
    NUMBER_OF_NEW_VOUCHERS:"Liczba kuponów w serii",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"W jednej serii można utworzyć od 1 do {{size}} kuponów",
    NEW_VOUCHERS_PREFIX:"Kod prefiksowy kuponu w serii",
    VALIDATION_VOUCHER_PREFIX:"Przedrostek kodu musi składać się z dokładnie 4 znaków (wielkie litery i / lub cyfry)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Wystąpił błąd podczas tworzenia nowych kuponów. Spróbuj ponownie lub skontaktuj się ze wsparciem technicznym",
    CREATE_VOUCHERS:"Utwórz nową serię kuponów",
    CREATING_VOUCHERS_SUCCESS:"Pomyślnie utworzono nową serię kuponów",
    PRINT_NEW_VOUCHERS:"Drukuj kupony",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Wprowadź numer serii kuponów, cały kod lub jego część, aby wydrukować odpowiednie kupony",
    PRINT_VOUCHERS_PREFIX:"Kod prefiksowy (seria) kuponów",
    NO_VOUCHERS_FOR_PRINT:"Brak kuponów do wydruku z wpisanym kodem prefiksowym",
    PRINT_VOUCHERS:"Drukuj kupony",
    VALIDATION_VOUCHER_CODE_FILTER:"Filtr kodu prefiksowego może zawierać od 1 do 16 znaków i obsługuje tylko wielkie litery i liczby",
    FILTER_VOUCHERS_BY_CODE:"Filtr kuponów według kodu",
    FILTER_VOUCHERS:"Search vouchers",
    WASH_BOX:"Umyj pudełko",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Łącznie zużytych cyfrowych tokenów",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Łącznie sprzedane lokalne tokeny według daty",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Łącznie wydane lokalne tokeny według daty",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Łącznie podane lokalne tokeny według daty",
    LOCAL_TOKEN:"Local token ",
    GIVEN_TOKEN:"Given local tokens",
    SOLD_TOKEN:"Sold local tokens",
    SMALL_MACHINES:"Small machines",
    R2W_Listener:"Listener",
    HHANLE_DEVICE:"HHanle - Umyj pudełko",
    CODE_PREFIX_EXIST:"Prefiks kodu już istnieje",
    CODE_PREFIX_EXIST_TEXT:"Nie możesz utworzyć nowego kuponu z tym prefiksem kodu. Ustaw inny.",
    MIN_FOUR_VALIDATION:"Dokładnie 4 znaki",
    ALL_INFORMATION_1:"Wszystkie informacje na temat",
    ALL_INFORMATION_2:"będzie zgubiony",
    ASIDE_MENU_TRANSACTIONS:"Transakcje",
    EXPENSES:"Wydatki",
    TOPUPS:"Kupione tokeny",
    EXPENSES_LIST:"Lista wydatków",
    USER_EMAIL:"Adres e-mail użytkownika",
    COMPANY_NAME:"Nazwa firmy",
    TOPUPS_LIST:"Lista zakupionych tokenów",
    CONSUMER:"Consumer",
    SYSTEM_ADMIN:"System administrator",
    MERCHANT_ADMIN:"Merchant administrator",
    COMPANY_ADMIN:"Company administrator",
    FACILITY_ADMIN:"Facility administator",
    SUBSCRIBER:"Subscriber",
    CONFIGURATOR:"Configurator",
    SETUP_UNIT_SERIAL_NO:"Serial number",
    SETUP_UNIT_MATERIAL_NO:"Material number",
    SETUP_UNIT_WEBAPI_VERSION:"WebApi version",
    TOTAL_TURNOVER:"Wash facility turnover",
    AVAILABILITY_ALL:"Availability",
    AVAILIBILITY:"Wash boxes availability:",
    AVAILABILITY_VACUUMS:"Vacuums availability:",
    WASH_BOX_INFO:"Wash boxes info",
    VACUUM_CLEANER_INFO:"Vacuum cleaners info",
    BREAD_CRUMBS_SERVICE:"Service",
    HOLIDAYS:"Holidays",
    LIGHTS_ON:"Lights on",
    LIGHTS_OFF:"Lights off",
    WASH_BOXES_ON:"Wash box on",
    WASH_BOXES_OFF:"Wash box off",
    VACUUMS_ON:"Vacuums on",
    VACUUMS_OFF:"Vacuums off",
    TURNOVER:"Turnover",
    TURNOVER_MANUAL_WASH_UNIT:"Turnover manual",
    STATUS_BAY_RUN_TIME:"Wash box total work time",
    STATUS_BAY_PROGRAM_NAME:"Program name",
    STATUS_BAY_CREDIT:"Wash box credit",
    CLOUD_KREDIT:"Cloud credit",
    STATUS_VACUUM_RUN_TIME:"Vacuum total work time",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Facility services, wash box program and current fault data information",
    UNAVAILABLE:"Unit is unavailable",
    SHOW_HIDE_TABLE:"Show/hide working hours table",
    PROGRAM_NAME:"Program name",
    PROGRAM_OPTION:"Program option",
    DEVICE:"Device",
    QUANTITY:"Quantity",
    PROGRAM_COUNTER:"Program counter",
    NO_NAME:"Reference has no name",
    COUNTER_SERVICE_DATA:"Service data",
    NEED_SERVICE:" Service needed",
    PROGRAM_DATA:"Wash box program data",
    CURRENT_FAULT_DATA:"Current fault data",
    REFERENCE_DUE:"Due",
    REFERENCE_SECONDS:"Seconds",
    REFERENCE_NAME:"Part name",
    WASHBOX_NAME:"Wash box name",
    FAULT_NAME:"Fault name",
    FAULT_NUMBER:"Fault number",
    CURRENT_FAULT_COUNT:"Active faults",
    DEVICE_NOT_INSTALLED:"Device not installed",
    STATUS_READY:"Gotowy status",
    STATUS_ERROR:"Status błędu",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:" Software error",
    SOFTWARE_RESET:" Software error",
    EXTERNAL_PIN_RESET:" Software error",
    RESTART_OR_BROWNOUT_OCCURRED:" Software error",
    DEAD_RM5_CHANNEL_PIN_ERROR:" Hardware error",
    COULD_NOT_SIMULATE_COIN:" Hardware error",
    ERROR_SETTING_INHIBIT_MODE:" Hardware error",
    OFFLINE_DEVICE:" Offline car wash",
    TARIFFS:" Tariffs",
    DAY:" Day",
    NIGHT:" Night",
    VOUCHER_CODE:" Voucher code",
    DISMISS_ALARM:" Reset alarm?",
    ALARM_ACTIVE:" Active alarms",
    NO_ALARM_ACTIVE:" There are no active alarms",
    ALARM_HISTORY:" Alert history",
    MANAGING_TOKENS:"Managing tokens",
    EXPIRATION_DATE:"Expiration date",
    EXTEND_TOKEN_DATE:"Extend token expiration date for",
    DELETE_TOKENS_FOR:"Delete tokens for ",
    PUMP_TYPE:"Pump type",
    TURN_OFF_DEVICE:" Device status",
    OPERATION_DATA:" Operation data",
    PUMP_DATA:" Pump data",
    PUMP_NAME:" Pump name",
    POINT_NAME:" Point name",
    CHANGER_INCOME:" Total changer income by date",
    SELECTED_OPEN:"Otwarte w wybrane godziny pracy",
    ALWAYS_OPEN:"Zawsze otwarte (24/7)",
    CLOSED:"Zamknięte",
    MON:"Poniedziałek",
    TUE:"Wtorek",
    WED:"Środa",
    THU:"Czwartek",
    FRI:"Piątek",
    SAT:"Sobota",
    SUN:"Niedziela ",
    KARCHER_ERROR_CODE:" Alert error code",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor BUFFER TANK EMPTY activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor BUFFER CONTAINER EMPTY and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor RO PUMP ON and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    SITE_DETAILS_SUCCESSFULLY_UPDATED: "Site details successfully updated",
    COMPANY: "Company",
    FACILITY_HAS_CHANGER: "Have changer?",
    DISABLE_OFFLINE_ALARM: "Disable R2W alarms",
    ASIDE_WORKING_SCHEDULES: "App Site details",
    TERMS_OF_SERVICE_R2W_TITLE: "Ready2Wash terms of service",
    TERMS_OF_SERVICE_R2W: "Ready2Wash terms of service",
    DATA_PROCESSING_TITLE: "Data Processed",
    PRIVACY_POLICY_TITLE: "Privacy Policy",
    READY_TO_PAY_TERMS_OF_SERVICE: "Ready2Pay Terms of service",
    TERMS_AND_SERVICES: "Terms and services",
    INFO_TITLE: "Info",
    HOURLY: "Co godzinę",
    DAILY: "Codziennie",
    WEEKLY: "Co tydzień",
    MONTHLY: "Co miesiąc",
    YEARLY: "Co roku",
    DELETE_ITEM_SUCCESS:"Pomyślnie usunięto element",
    STATE: "Stan",
    AVAILABILITY_STATUS_1: "Jednostka otwarta",
    AVAILABILITY_STATUS_2: "Jednostka zamknięta (wakacje)",
    AVAILABILITY_STATUS_3: "Jednostka zamknięta (godziny pracy)",
    AVAILABILITY_STATUS_4: "Jednostka zamknięta (awaria)",
    AVAILABILITY_STATUS_5: "Jednostka zamknięta (inne)",
    AVAILABILITY_VACUUMS_STATUS_1: "Odkurzacze nie zainstalowane",
    AVAILABILITY_VACUUMS_STATUS_2: "Odkurzacze otwarte",
    AVAILABILITY_VACUUMS_STATUS_3: "Odkurzacze zamknięte (wakacje)",
    AVAILABILITY_VACUUMS_STATUS_4: "Odkurzacze zamknięte (godziny pracy)",
    AVAILABILITY_VACUUMS_STATUS_5: "Odkurzacze zamknięte (awaria)",
    AVAILABILITY_VACUUMS_STATUS_6: "Odkurzacze zamknięte (inne)",
    ECOM_AMOUNT: "Całkowity Ecom dla wszystkich lokalizacji",
    CAPTURED: "Zarejestrowano",
    G0:"{{brand === 'r2w' ? 'Bay 0' : 'Bay 1'}}",
    G1:"{{brand === 'r2w' ? 'Bay 1' : 'Bay 2'}}",
    G2:"{{brand === 'r2w' ? 'Bay 2' : 'Bay 3'}}",
    G3:"{{brand === 'r2w' ? 'Bay 3' : 'Bay 4'}}",
    G4:"{{brand === 'r2w' ? 'Bay 4' : 'Bay 5'}}",
    G5:"{{brand === 'r2w' ? 'Bay 5' : 'Bay 6'}}",
    G6:"{{brand === 'r2w' ? 'Bay 6' : 'Bay 7'}}",
    G7:"{{brand === 'r2w' ? 'Bay 7' : 'Bay 8'}}",
    G8:"{{brand === 'r2w' ? 'Bay 8' : 'Bay 9'}}",
    G9:"{{brand === 'r2w' ? 'Bay 9' : 'Bay 10'}}",
    G10:"{{brand === 'r2w' ? 'Bay 10' : 'Bay 11'}}",
    U0:"{{brand === 'r2w' ? 'Vacuum 0' : 'Vacuum 1'}}",
    U1:"{{brand === 'r2w' ? 'Vacuum 1' : 'Vacuum 2'}}",
    U2:"{{brand === 'r2w' ? 'Vacuum 2' : 'Vacuum 3'}}",
    U3:"{{brand === 'r2w' ? 'Vacuum 3' : 'Vacuum 4'}}",
    U4:"{{brand === 'r2w' ? 'Vacuum 4' : 'Vacuum 5'}}",
    U5:"{{brand === 'r2w' ? 'Vacuum 5' : 'Vacuum 6'}}",
    U6:"{{brand === 'r2w' ? 'Vacuum 6' : 'Vacuum 7'}}",
    U7:"{{brand === 'r2w' ? 'Vacuum 7' : 'Vacuum 8'}}",
    DELETE_COMPANY_HISTORY_INFO:"Ta akcja usunie wszystkie dane raportów Twojej firmy. Tej akcji nie można cofnąć.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Czy na pewno chcesz trwale usunąć wszystkie dane raportów?",
    VALUE_DATE: "Data waluty",
    KARCHER_EVENT_NAME_1: "Podstawowy wymiennik ciepła zregenerowany",
    KARCHER_EVENT_NAME_2: "Regeneracja podstawowego wymiennika ciepła zakończona",
    KARCHER_EVENT_NAME_3: "Materiał / numer seryjny",
    KARCHER_EVENT_NAME_4: "System został zdezynfekowany",
    KARCHER_EVENT_NAME_5: "Pompa HP 1 zdezynfekowana",
    KARCHER_EVENT_NAME_6: "Pompa HP 2 zdezynfekowana",
    KARCHER_EVENT_NAME_7: "Pompa HP 3 zdezynfekowana",
    KARCHER_EVENT_NAME_8: "Pompa HP 4 zdezynfekowana",
    KARCHER_EVENT_NAME_9: "Pompa HP 5 zdezynfekowana",
    KARCHER_EVENT_NAME_10: "Stacja myjąca 1 zablokowana",
    KARCHER_EVENT_NAME_11: "Stacja myjąca 2 zablokowana",
    KARCHER_EVENT_NAME_12: "Stacja myjąca 3 zablokowana",
    KARCHER_EVENT_NAME_13: "Stacja myjąca 4 zablokowana",
    KARCHER_EVENT_NAME_14: "Stacja myjąca 5 zablokowana",
    KARCHER_EVENT_NAME_15: "Stacja myjąca 6 zablokowana",
    KARCHER_EVENT_NAME_16: "Stacja myjąca 7 zablokowana",
    KARCHER_EVENT_NAME_17: "Stacja myjąca 8 zablokowana",
    KARCHER_EVENT_NAME_18: "Aktualizacja rozpoczęta",
    KARCHER_EVENT_NAME_19: "Aktualizacja zakończona",
    KARCHER_EVENT_NAME_20: "Start WS Reg",
    KARCHER_EVENT_NAME_21: "Koniec WS Reg",
    KARCHER_EVENT_NAME_22: "Czujnik WS 75%",
    KARCHER_EVENT_NAME_23: "Usterka techniczna",
    KARCHER_EVENT_NAME_24: "Usterka operacyjna",
    KARCHER_EVENT_NAME_25: "Jednostka włączona",
    KARCHER_EVENT_NAME_26: "Jednostka wyłączona",
    KARCHER_EVENT_NAME_27: "Skrzynka 1 zamknięta",
    KARCHER_EVENT_NAME_28: "Skrzynka 2 zamknięta",
    KARCHER_EVENT_NAME_29: "Skrzynka 3 zamknięta",
    KARCHER_EVENT_NAME_30: "Skrzynka 4 zamknięta",
    KARCHER_EVENT_NAME_31: "Skrzynka 5 zamknięta",
    KARCHER_EVENT_NAME_32: "Skrzynka 6 zamknięta",
    KARCHER_EVENT_NAME_33: "Skrzynka 7 zamknięta",
    KARCHER_EVENT_NAME_34: "Skrzynka 8 zamknięta",
    KARCHER_EVENT_NAME_35: "Stacja pomp HP 1",
    KARCHER_EVENT_NAME_36: "Stacja pomp HP 2",
    KARCHER_EVENT_NAME_37: "Stacja pomp HP 3",
    KARCHER_EVENT_NAME_38: "Stacja pomp HP 4",
    KARCHER_EVENT_NAME_39: "Stacja pomp HP 5",
    KARCHER_EVENT_NAME_40: "Stacja pomp HP 6",
    KARCHER_EVENT_NAME_41: "Stacja pomp HP 7",
    KARCHER_EVENT_NAME_42: "Stacja pomp HP 8",
    KARCHER_EVENT_NAME_43: "Palnik",
    KARCHER_EVENT_NAME_44: "Wentylator palnika",
    KARCHER_EVENT_NAME_45: "Pompa ciepłej wody",
    KARCHER_EVENT_NAME_46: "Pompa przeciwzamrożeniowa",
    KARCHER_EVENT_NAME_47: "Pompa osmotyczna",
    KARCHER_EVENT_NAME_48: "Ogrzewanie podłogowe",
    KARCHER_EVENT_NAME_49: "Podgrzewanie węża",
    KARCHER_EVENT_NAME_50: "Czyszczenie mikro / felg",
    KARCHER_EVENT_NAME_51: "Pompa do mycia podwozia",
    KARCHER_EVENT_NAME_52: "Pompa Boostera piany",
    KARCHER_EVENT_NAME_53: "Odkurzacz 1",
    KARCHER_EVENT_NAME_54: "Odkurzacz 2",
    KARCHER_EVENT_NAME_55: "Odkurzacz 3",
    KARCHER_EVENT_NAME_56: "Odkurzacz 4",
    KARCHER_EVENT_NAME_57: "Odkurzacz 5",
    KARCHER_EVENT_NAME_58: "Odkurzacz 6",
    KARCHER_EVENT_NAME_59: "Odkurzacz 7",
    KARCHER_EVENT_NAME_60: "Odkurzacz 8",
    KARCHER_EVENT_NAME_61: "Odkurzacz 9",
    KARCHER_EVENT_NAME_62: "Odkurzacz 10",
    KARCHER_EVENT_NAME_63: "Odkurzacz 11",
    KARCHER_EVENT_NAME_64: "Odkurzacz 12",
    KARCHER_EVENT_NAME_65: "Pompa do czyszczenia felg",
    KARCHER_EVENT_NAME_66: "Pompa mikro",
    KARCHER_EVENT_NAME_67: "Pompa intensywna",
    KARCHER_EVENT_NAME_68: "Turbina odkurzacza 1",
    KARCHER_EVENT_NAME_69: "Filtr odkurzacza 1",
    KARCHER_EVENT_NAME_70: "Turbina odkurzacza 2",
    KARCHER_EVENT_NAME_71: "Filtr odkurzacza 2",
    KARCHER_EVENT_NAME_72: "Turbina odkurzacza 3",
    KARCHER_EVENT_NAME_73: "Filtr odkurzacza 3",
    KARCHER_EVENT_NAME_74: "Turbina odkurzacza 4",
    KARCHER_EVENT_NAME_75: "Filtr odkurzacza 4",
    KARCHER_EVENT_NAME_76: "Turbina odkurzacza 5",
    KARCHER_EVENT_NAME_77: "Filtr odkurzacza 5",
    KARCHER_EVENT_NAME_78: "Turbina odkurzacza 6",
    KARCHER_EVENT_NAME_79: "Filtr odkurzacza 6",
    KARCHER_EVENT_NAME_80: "Turbina odkurzacza 7",
    KARCHER_EVENT_NAME_81: "Filtr odkurzacza 7",
    KARCHER_EVENT_NAME_82: "Turbina odkurzacza 8",
    KARCHER_EVENT_NAME_83: "Filtr odkurzacza 8",
    KARCHER_EVENT_NAME_84: "Turbina odkurzacza 9",
    KARCHER_EVENT_NAME_85: "Filtr odkurzacza 9",
    KARCHER_EVENT_NAME_86: "Turbina odkurzacza 10",
    KARCHER_EVENT_NAME_87: "Filtr odkurzacza 10",
    KARCHER_EVENT_NAME_88: "Turbina odkurzacza 11",
    KARCHER_EVENT_NAME_89: "Filtr odkurzacza 11",
    KARCHER_EVENT_NAME_90: "Turbina odkurzacza 12",
    KARCHER_EVENT_NAME_91: "Filtr odkurzacza 12",
    INSERT_TOKEN: "Wprowadź tokeny i uruchom usługę",
    OPEN_SESSION: "Sesja została pomyślnie otwarta",
    IN_PROGRESS: "W trakcie ...",
    TOKEN_INSERTED: "Tokeny zostały pomyślnie wprowadzone",
    EXPIRED_SESSION: "Sesja wygasła",
    TWO_DIGIT_INTEGER_VALIDATION: "Użyj maksymalnie dwucyfrowej liczby całkowitej",
    KARCHER_OPERATION_COUNTER_1: "Stanowisko mycia 1 pompa HD",
    KARCHER_OPERATION_COUNTER_2: "Stanowisko mycia 1 pompa środka chemicznego 1",
    KARCHER_OPERATION_COUNTER_3: "Stanowisko mycia 1 pompa środka chemicznego 2",
    KARCHER_OPERATION_COUNTER_4: "Stanowisko mycia 1 pompa środka chemicznego 3",
    KARCHER_OPERATION_COUNTER_5: "Stanowisko mycia 1 pompa środka chemicznego 4",
    KARCHER_OPERATION_COUNTER_6: "Stanowisko mycia 2 pompa HD",
    KARCHER_OPERATION_COUNTER_7: "Stanowisko mycia 2 pompa środka chemicznego 1",
    KARCHER_OPERATION_COUNTER_8: "Stanowisko mycia 2 pompa środka chemicznego 2",
    KARCHER_OPERATION_COUNTER_9: "Stanowisko mycia 2 pompa środka chemicznego 3",
    KARCHER_OPERATION_COUNTER_10: "Stanowisko mycia 2 pompa środka chemicznego 4",
    KARCHER_OPERATION_COUNTER_11: "Stanowisko mycia 3 pompa HD",
    KARCHER_OPERATION_COUNTER_12: "Stanowisko mycia 3 pompa środka chemicznego 1",
    KARCHER_OPERATION_COUNTER_13: "Stanowisko mycia 3 pompa środka chemicznego 2",
    KARCHER_OPERATION_COUNTER_14: "Stanowisko mycia 3 pompa środka chemicznego 3",
    KARCHER_OPERATION_COUNTER_15: "Stanowisko mycia 3 pompa środka chemicznego 4",
    KARCHER_OPERATION_COUNTER_16: "Stanowisko mycia 4 pompa HD",
    KARCHER_OPERATION_COUNTER_17: "Stanowisko mycia 4 pompa środka chemicznego 1",
    KARCHER_OPERATION_COUNTER_18: "Stanowisko mycia 4 pompa środka chemicznego 2",
    KARCHER_OPERATION_COUNTER_19: "Stanowisko mycia 4 pompa środka chemicznego 3",
    KARCHER_OPERATION_COUNTER_20: "Stanowisko mycia 4 pompa środka chemicznego 4",
    KARCHER_OPERATION_COUNTER_21: "Stanowisko mycia 5 pompa HD",
    KARCHER_OPERATION_COUNTER_22: "Stanowisko mycia 5 pompa środka chemicznego 1",
    KARCHER_OPERATION_COUNTER_23: "Stanowisko mycia 5 pompa środka chemicznego 2",
    KARCHER_OPERATION_COUNTER_24: "Stanowisko mycia 5 pompa środka chemicznego 3",
    KARCHER_OPERATION_COUNTER_25: "Stanowisko mycia 5 pompa środka chemicznego 4",
    KARCHER_OPERATION_COUNTER_26: "Stanowisko mycia 6 pompa HD",
    KARCHER_OPERATION_COUNTER_27: "Stanowisko mycia 6 pompa środka chemicznego 1",
    KARCHER_OPERATION_COUNTER_28: "Stanowisko mycia 6 pompa środka chemicznego 2",
    KARCHER_OPERATION_COUNTER_29: "Stanowisko mycia 6 pompa środka chemicznego 3",
    KARCHER_OPERATION_COUNTER_30: "Stanowisko mycia 6 pompa środka chemicznego 4",
    KARCHER_OPERATION_COUNTER_31: "Stanowisko mycia 7 pompa HD",
    KARCHER_OPERATION_COUNTER_32: "Stanowisko mycia 7 pompa środka chemicznego 1",
    KARCHER_OPERATION_COUNTER_33: "Stanowisko mycia 7 pompa środka chemicznego 2",
    KARCHER_OPERATION_COUNTER_34: "Stanowisko mycia 7 pompa środka chemicznego 3",
    KARCHER_OPERATION_COUNTER_35: "Stanowisko mycia 7 pompa środka chemicznego 4",
    KARCHER_OPERATION_COUNTER_36: "Stanowisko mycia 8 pompa HD",
    KARCHER_OPERATION_COUNTER_37: "Stanowisko mycia 8 pompa środka chemicznego 1",
    KARCHER_OPERATION_COUNTER_38: "Stanowisko mycia 8 pompa środka chemicznego 2",
    KARCHER_OPERATION_COUNTER_39: "Stanowisko mycia 8 pompa środka chemicznego 3",
    KARCHER_OPERATION_COUNTER_40: "Stanowisko mycia 8 pompa środka chemicznego 4",
    KARCHER_OPERATION_COUNTER_41: "Pompa wody osmotycznej",
    KARCHER_OPERATION_COUNTER_42: "Podgrzewacz gorącej wody",
    KARCHER_OPERATION_COUNTER_43: "Pompa ochrony przed zamarzaniem",
    KARCHER_OPERATION_COUNTER_44: "Wkład filtra WSO",
    KARCHER_OPERATION_COUNTER_45: "Pompa ogrzewania myjni",
    KARCHER_OPERATION_COUNTER_46: "Pompa ciepłej wody",
    KARCHER_OPERATION_COUNTER_47: "Ogrzewanie węża pianowego",
    KARCHER_OPERATION_COUNTER_48: "Pompa środka do czyszczenia felg",
    KARCHER_OPERATION_COUNTER_49: "Pompa mikroemulsji",
    KARCHER_OPERATION_COUNTER_50: "Pompa piany intensywnej",
    KARCHER_OPERATION_COUNTER_51: "Ssawka 1 turbina 1",
    KARCHER_OPERATION_COUNTER_52: "Ssawka 1 filtr 1",
    KARCHER_OPERATION_COUNTER_53: "Ssawka 1 turbina 2",
    KARCHER_OPERATION_COUNTER_54: "Ssawka 1 filtr 2",
    KARCHER_OPERATION_COUNTER_55: "Ssawka 2 turbina 1",
    KARCHER_OPERATION_COUNTER_56: "Ssawka 2 filtr 1",
    KARCHER_OPERATION_COUNTER_57: "Ssawka 2 turbina 2",
    KARCHER_OPERATION_COUNTER_58: "Ssawka 2 filtr 2",
    KARCHER_OPERATION_COUNTER_59: "Ssawka 3 turbina 1",
    KARCHER_OPERATION_COUNTER_60: "Ssawka 3 filtr 1",
    KARCHER_OPERATION_COUNTER_61: "Ssawka 3 turbina 2",
    KARCHER_OPERATION_COUNTER_62: "Ssawka 3 filtr 2",
    KARCHER_OPERATION_COUNTER_63: "Ssawka 4 turbina 1",
    KARCHER_OPERATION_COUNTER_64: "Ssawka 4 filtr 1",
    KARCHER_OPERATION_COUNTER_65: "Ssawka 4 turbina 2",
    KARCHER_OPERATION_COUNTER_66: "Ssawka 4 filtr 2",
    KARCHER_OPERATION_COUNTER_67: "Ssawka 5 turbina 1",
    KARCHER_OPERATION_COUNTER_68: "Ssawka 5 filtr 1",
    KARCHER_OPERATION_COUNTER_69: "Ssawka 5 turbina 2",
    KARCHER_OPERATION_COUNTER_70: "Ssawka 5 filtr 2",
    KARCHER_OPERATION_COUNTER_71: "Ssawka 6 turbina 1",
    KARCHER_OPERATION_COUNTER_72: "Ssawka 6 filtr 1",
    KARCHER_OPERATION_COUNTER_73: "Ssawka 6 turbina 2",
    KARCHER_OPERATION_COUNTER_74: "Ssawka 6 filtr 2",
    KARCHER_OPERATION_COUNTER_75: "Spuścić kondensat przy kompresorze",
    KARCHER_OPERATION_COUNTER_76: "Sprawdzić system ochrony przed zamarzaniem",
    KARCHER_OPERATION_COUNTER_77: "Dmuchawa palnika",
    KARCHER_OPERATION_COUNTER_78: "Piana pompy wspomagającej",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Lista danych jest większa niż 10000 pozycji",
    KARCHER_POINT_NAME_1: "Święto",
    KARCHER_POINT_NAME_2: "Poniedziałek",
    KARCHER_POINT_NAME_3: "Wtorek",
    KARCHER_POINT_NAME_4: "Środa",
    KARCHER_POINT_NAME_5: "Czwartek",
    KARCHER_POINT_NAME_6: "Piątek",
    KARCHER_POINT_NAME_7: "Sobota",
    KARCHER_POINT_NAME_8: "Niedziela",
    KARCHER_POINT_NAME_9: "Odkurzacze Święto",
    KARCHER_POINT_NAME_10: "Odkurzacze Poniedziałek",
    KARCHER_POINT_NAME_11: "Odkurzacze Wtorek",
    KARCHER_POINT_NAME_12: "Odkurzacze Środa",
    KARCHER_POINT_NAME_13: "Odkurzacze Czwartek",
    KARCHER_POINT_NAME_14: "Odkurzacze Piątek",
    KARCHER_POINT_NAME_15: "Odkurzacze Sobota",
    KARCHER_POINT_NAME_16: "Odkurzacze Niedziela",
    KARCHER_POINT_NAME_17: "Oświetlenie Święto",
    KARCHER_POINT_NAME_18: "Oświetlenie Poniedziałek",
    KARCHER_POINT_NAME_19: "Oświetlenie Wtorek",
    KARCHER_POINT_NAME_20: "Oświetlenie Środa",
    KARCHER_POINT_NAME_21: "Oświetlenie Czwartek",
    KARCHER_POINT_NAME_22: "Oświetlenie Piątek",
    KARCHER_POINT_NAME_23: "Oświetlenie Sobota",
    KARCHER_POINT_NAME_24: "Oświetlenie Niedziela",
    KARCHER_POINT_NAME_25: "Program 0",
    KARCHER_POINT_NAME_26: "Program 1",
    KARCHER_POINT_NAME_27: "Program 2",
    KARCHER_POINT_NAME_28: "Program 3",
    KARCHER_POINT_NAME_29: "Program 4",
    KARCHER_POINT_NAME_30: "Program 5",
    KARCHER_POINT_NAME_31: "Program 6",
    KARCHER_POINT_NAME_32: "Program 7",
    KARCHER_POINT_NAME_33: "Program 8",
    KARCHER_POINT_NAME_34: "Program 9",
    KARCHER_POINT_NAME_35: "Program 10",
    KARCHER_POINT_NAME_36: "Program 11",
    KARCHER_POINT_NAME_37: "Program 12",
    KARCHER_POINT_NAME_38: "Program 13",
    KARCHER_POINT_NAME_39: "Program 14",
    KARCHER_POINT_NAME_40: "Program 15",
    KARCHER_POINT_NAME_41: "Program 16",
    KARCHER_POINT_NAME_42: "Program 17",
    KARCHER_POINT_NAME_43: "Program 18",
    KARCHER_POINT_NAME_44: "Program 19",
    KARCHER_POINT_NAME_45: "Program 20",
    KARCHER_POINT_NAME_46: "Program 21",
    KARCHER_POINT_NAME_47: "Program 22",
    KARCHER_POINT_NAME_48: "Program 23",
    KARCHER_POINT_NAME_49: "Program 24",
    KARCHER_POINT_NAME_50: "Program 25",
    KARCHER_POINT_NAME_51: "Program 26",
    KARCHER_POINT_NAME_52: "Program 27",
    KARCHER_POINT_NAME_53: "Program 28",
    KARCHER_POINT_NAME_54: "Program 29",
    KARCHER_POINT_NAME_55: "Program 30",
    KARCHER_POINT_NAME_56: "Program 31",
    KARCHER_POINT_NAME_57: "Program 32",
    QR_CODE: "Kod QR",
    ACCEPT_TERMS_AND_CONDITIONS: "Zaakceptuj warunki korzystania",
    CREATE_AND_PRINT_VOUCHERS: "Utwórz i drukuj kupony",
    CODE_PREFIX_QUESTION: "Prefiks kodu nie jest wprowadzony",
    CODE_PREFIX_QUESTION_TEXT: "Czy chcesz kontynuować bez prefiksu kodu?",
    ISSUED_DATE: "Data wydania",
    VOUCHER_VALIDITY_DAYS: "Ważność kuponu (dni)",
    IDENTIFICATION_CODE: "Kod identyfikacyjny",
    VALIDATION_ONLY_NUMBERS: "Dozwolone są tylko liczby",
    REPRINT_VOUCHERS: "Drukuj kopię kuponów",
    EXPIRY_DATE: "Ważny do",
    VOUCHER_TYPE_VACUUM: "Kupon na: Odkurzacz",
    VOUCHER_TYPE_JETWASH: "Kupon na: Jet Wash Care",
    VOUCHER_TYPE_MATT: "Kupon na: Matt"
  });
})();
